module.exports = __webpack_public_path__ + "img/serveOrder.d5d82121.png";